// @flow

import * as React from 'react';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {CaptionCaps} from 'sail/Text';
import {DocsIcon} from 'docs/components';
import type {DocsIconCategory} from 'docs/components';

type CardFooterProps = {|
  children: React.Node,
  icon: string | {|category: DocsIconCategory, icon: string|},
|};

export const CardFooter = ({children, icon}: CardFooterProps) => {
  const iconProps = typeof icon === 'string' ? {icon} : icon;
  return (
    <Box flex style={{marginTop: 'auto'}} className="Card-footer">
      <Group
        direction="horizontal"
        alignItems="center"
        padding={{top: 12}}
        spacing={8}
      >
        <DocsIcon {...iconProps} size={20} />
        <CaptionCaps>{children}</CaptionCaps>
      </Group>
    </Box>
  );
};
